<template>
    <div>
        <div v-if="state === undefined || state == null">
            <div class="tooltip">
                <font-awesome-icon :icon="['fas', 'question-circle']" color="grey"/>
                <span class="tooltip-text">
                    {{$t('text.unknown')}}
                </span>
            </div>
        </div>
        <div v-else-if="state === 0">
            <div class="tooltip">
                <font-awesome-icon :icon="['fas', 'thumbs-up']" color="green"/>
                <span class="tooltip-text">
                    {{this.$t('text.capability.state_0')}}
                </span>
            </div>
        </div>
        <div v-else-if="state === 1">
            <div class="tooltip">
                <font-awesome-icon :icon="['fas', 'thumbs-up']" color="gold"/>
                <span class="tooltip-text">
                    {{this.$t('text.capability.state_1')}}
                </span>
            </div>
        </div>
        <div v-else-if="state === 2">
            <div class="tooltip">
                <font-awesome-icon :icon="['fas', 'thumbs-down']" color="orange"/>
                <span class="tooltip-text">
                    {{this.$t('text.capability.state_2')}}
                </span>
            </div>
        </div>
        <div v-else-if="state === 3">
            <div class="tooltip">
                <font-awesome-icon :icon="['fas', 'thumbs-down']" color="red"/>
                <span class="tooltip-text">
                    {{this.$t('text.capability.state_3')}}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PatientCapabilityState",
        props: {
            state: {
                type: Number,
                required: true
            }
        },
    }
</script>

<style scoped>
    .tooltip {
        position: relative;
        display: inline-block;
    }

    .tooltip .tooltip-text {
        visibility: hidden;
        width: 120px;
        background-color: #555;
        color: #fff;
        text-align: center;
        padding: 5px 0;
        border-radius: 6px;

        position: absolute;
        z-index: 1;
        bottom: 125%;
        left: 50%;
        margin-left: -60px;

        opacity: 0;
        transition: opacity 0.3s;
    }

    .tooltip .tooltip-text::after {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: #555 transparent transparent transparent;
    }

    .tooltip:hover .tooltip-text {
        visibility: visible;
        opacity: 1;
    }
</style>